module.exports = __webpack_public_path__ + "static/media/Scene-2.aef3c06d.jpg";